import { Checkbox, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import React from 'react';

let BsResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Results.AvgParticleDensity" />
      </ListFieldSection>
      <WorksheetsResultsMessagesSection />

      <ListFieldSection heading="Optional Results">
        <Field input={<TextOutput />} name="Results.MaterialRetainedOn50_0mmSieve" />
        <Field input={<TextOutput />} name="Results.MaterialRetainedOn37_5mmSieve" />
        <Field input={<TextOutput />} name="Results.SievingMethod" />
      </ListFieldSection>

      <ListFieldSection heading="Report">
        <Field input={<Checkbox />} name="Results.ReportSievingResults" />
      </ListFieldSection>
    </>
  );
};

BsResultsSection = withInjectedProps(BsResultsSection);

export { BsResultsSection };
export default BsResultsSection;
